import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { Container, ContainerStyle } from "../theme/common";
import { HeadingSection } from "../theme/components/HeadingSection";
import { COMMON, SPACING } from "../theme/palette";
const iconSize = SPACING.space3xl;
// Const gridGutter = `var(${SPACING.spacexss} , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))`;
const Card = styled("div")(() => ({
    "display": "grid",
    "flex": "1 0 20rem",
    "gridTemplateRows": `repeat(2, calc(${iconSize} / 2)) auto`,
    "maxWidth": "20rem",
    "width": "100%"
}));
const CardList = styled("div")(() => ({
    "--space": SPACING.spacexss,
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "var(--space , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))",
    "justifyContent": "center"
}));
const CardBackground = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.background.paper,
    "borderRadius": "21px",
    "gridColumn": 1,
    "gridRow": "2/span 2",
    "padding": "30px",
    "paddingTop": `calc(${iconSize} / 1.5)`,
    "textAlign": "center"
}));
const CardHeadingStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h4), { "color": theme.palette.primary.dark, "marginBottom": SPACING.spaces })));
const IconStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.common.white,
    "blockSize": iconSize,
    "borderRadius": "90rem",
    "boxShadow": COMMON.shadow1,
    "img": {
        "blockSize": "100%",
        "inlineSize": "100%",
        "padding": SPACING.spacexs
    },
    "margin": "0px auto",
    "zIndex": 1
}));
const HeadingSectionContainerStyle = styled("div")(() => ({
    "margin": " 0px auto",
    "maxInlineSize": " calc(77rem * .65)",
}));
const IconCard = (props) => {
    const { card, sectionHeading, sectionSubHeading } = props.properties;
    const [cardsData, setCardsData] = useState([]);
    useEffect(() => {
        const data = [];
        if (window.Array.isArray(card)) {
            card.forEach((ele) => {
                const parsedData = window.JSON.parse(ele);
                data.push(parsedData);
            });
            setCardsData(data);
        }
    }, [card]);
    return (_jsx(ThemeProvider, { children: _jsx(ContainerStyle, { children: _jsxs(Container, { children: [_jsx(HeadingSectionContainerStyle, { children: _jsx(HeadingSection, { sectionHeading: sectionHeading, sectionSubHeading: sectionSubHeading }) }), _jsx(CardList, { children: cardsData.map((rec, index) => (_jsxs(Card, { children: [_jsx(IconStyle, { children: _jsx("img", { alt: rec.title, src: rec.icon }) }), _jsxs(CardBackground, { children: [isNotUndefinedOrNull(rec.title) ? (_jsx(CardHeadingStyle, { children: rec.title })) : (_jsx(_Fragment, {})), _jsx(Typography, Object.assign({ variant: "h6" }, { children: rec.subTitle }))] })] }, `${rec.title}-${index}`))) })] }) }) }));
};
const iconCard = (renderableData) => renderIdentifierGeneric(IconCard, renderableData);
export { iconCard };
